<template>
  <div class="login-container">
    <el-card class="login-card">
      <div class="title">That's Chinese 后台管理系统</div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-user" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading" class="login-button">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login } from '@/api/user'

export default {
  name: 'AdminLogin',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loading: false,
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return

        this.loading = true
        try {
          // login 返回的是接口的 data 部分，包含 token、role、username
          const response = await login(this.loginForm)

          localStorage.setItem('token', response.token)
          localStorage.setItem('role', response.role)
          localStorage.setItem('username', response.username)

          this.$message.success('登录成功')
          this.$router.replace({ path: '/admin/dashboard' })
        } catch (error) {
          console.error('登录失败:', error)
          this.loginForm.password = ''
          this.$message.error(error.message || '用户名或密码错误')
        } finally {
          this.loading = false
        }
      })
    }


  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  padding: 20px;
}

.title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #303133;
}

.login-button {
  width: 100%;
}
</style> 